<template>
  <div>
    <v-btn v-if="!isSidebar" small text @click="goBack"
      ><v-icon small color="primary">mdi-keyboard-backspace</v-icon> Back
    </v-btn>
    <v-card v-if="Boolean(provider)" class="grey lighten-4" flat>
      <v-list-item>
        <v-list-item-avatar>
          <v-icon x-large> mdi-account-circle </v-icon>
        </v-list-item-avatar>
        <v-list-item-content>
          <v-list-item-title>{{
            provider.firstName + " " + provider.lastName
          }}</v-list-item-title>
          <v-list-item-subtitle
            >Email:
            {{
              provider.workEmailAddress ?? provider.emailAddress
            }}</v-list-item-subtitle
          >
        </v-list-item-content>
      </v-list-item>
    </v-card>
    <v-tabs>
      <v-tab>Profile</v-tab>
      <v-tab>Cases</v-tab>
      <v-tab-item>
        <provider-form :providerId="providerId"></provider-form>
      </v-tab-item>
      <v-tab-item>
        <provider-cases
          :assignments="assignments"
          :loading="isLoading"
        ></provider-cases>
      </v-tab-item>
    </v-tabs>
  </div>
</template>

<script>
import ProviderForm from "./provider-form";
import ProviderCases from "./provider-cases";
export default {
  props: ["providerId", "isSidebar"],
  components: {
    ProviderForm,
    ProviderCases,
  },
  data() {
    return {
      provider: null,
      assignments: [],
      isLoading: false,
    };
  },
  async mounted() {
    this.provider = this.$store.getters["optionsModule/getProviderById"](
      this.providerId
    );
    this.isLoading = true;
    this.assignments = await this.$store.dispatch(
      "plansModule/getAssignmentsForProvider",
      this.providerId
    );
    this.isLoading = false;
  },
  methods: {
    goBack() {
      this.$router.push({ name: "ProviderLookup" });
    },
  },
};
</script>
